import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import ReportCard from "./ReportCard";

export default function ResultPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-gray-700">
      <Headerdash />
      <Sidebar />
      <main className="min-h-screen pt-20 sm:pl-72">
        <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <ReportCard />
        </div>
      </main>
    </div>
  );
}
